export default __webpack_public_path__ + "static/media/success.bc1400b1.svg";